import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppDispatch } from '../store';
import NafListManagement from '../components/nafLists/NafListManagement';
import { 
  fetchNafCodes,
  selectNafCodes,
  selectIsLoadingNafCodes
} from '../store/slices/nouveauxAdherentsSlice';

const NafListsPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const nafCodes = useSelector(selectNafCodes);
  const isLoadingNafCodes = useSelector(selectIsLoadingNafCodes);

  // Fetch NAF codes on mount if they're not loaded yet
  useEffect(() => {
    if (!nafCodes && !isLoadingNafCodes) {
      dispatch(fetchNafCodes());
    }
  }, [dispatch, nafCodes, isLoadingNafCodes]);

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Back button */}
      <div className="-mt-4 mb-6">
        <Link
          to="/nouveaux-adherents"
          className="text-blue-600 hover:text-blue-800 flex items-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Retour à la prospection
        </Link>
      </div>

      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Listes NAF prédéfinies</h1>
        <p className="mt-2 text-sm text-gray-600">
          Créez et gérez des listes de codes NAF prédéfinies pour faciliter vos recherches de prospection.
          Ces listes sont partagées avec tous les utilisateurs de votre entreprise.
        </p>
      </div>

      <NafListManagement 
        nafCodes={nafCodes || []}
        isLoadingNafCodes={isLoadingNafCodes}
      />
    </div>
  );
};

export default NafListsPage; 